import Vue from 'vue'
import Vuex from 'vuex'
import user from "./modules/user"
import app from "./modules/app";

import getters from './getters'

Vue.use(Vuex)

//创建Vuex实 例
const store = new Vuex.Store({
  modules: {
    user,
    app
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js